import { ProductRepository } from '../repositories/ProductRepository';
import { diContainer, serviceNames } from '../../service-setup/diContainer';

export interface IFavoriteUpdatedEventData {
    skuBaseId: number;
    isFavorite: boolean;
    isAlreadyAdded?: boolean;
}

export class FavoriteUpdatedUseCase {
    private productRepository: ProductRepository;
    private skuBaseId: number;
    private isFavorite: boolean;
    private isAlreadyAdded: boolean;

    constructor(skuBaseId: number, isFavorite: boolean, isAlreadyAdded: boolean = false) {
        this.skuBaseId = skuBaseId;
        this.isFavorite = isFavorite;
        this.isAlreadyAdded = isAlreadyAdded;
        this.productRepository = diContainer.get(serviceNames.productRepository);
    }

    public execute = () => {
        if (!this.isAlreadyAdded) {
            this.productRepository.updateFavorites([this.skuBaseId], this.isFavorite);
        }
    };
}
